import { lazy } from '@sorare/core/src/lib/retry';

export const MyBidsPictureInPictureWindow = lazy(
  async () => import('./Window.tsx'),
  'MyBidsPictureInPictureWindow'
);
